module.exports = __webpack_public_path__ + "static/media/indonesia.18a6deee.svg";